/**
 * Strategies object generated by Goal app.
 *
 * @typedef {Object} Strategies
 * @namespace
 *
 * @memberof module:Goal.Model.Entity
 *
 * @property {String} milestone The milestone strategy.
 * @property {String} overflow The overflow strategy.
 * @property {String} fraud The fraud strategy.
 */
class Strategies {

	constructor(milestone, overflow, fraud) {

		this.milestone = milestone;
		this.overflow = overflow;
		this.fraud = fraud;
	}
}

export default Strategies;